var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.resourceBlockContainer] = true, _class[_vm.$style.minimalDesign] = _vm.minimalDesign, _class['light-transparent'] = _vm.isTransparent, _class),
    attrs: {
      "data-resource-block": ""
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.isTransparent = true;
      },
      "mouseout": function mouseout($event) {
        _vm.isTransparent = false;
      },
      "click": _vm.viewResource
    }
  }, [_c('div', {
    class: _vm.$style.heading
  }, [_c('div', {
    class: _vm.$style.titleContainer
  }, [true ? _c('ResourceIcon', {
    attrs: {
      "name": _vm.resourceIcon,
      "file-extension": _vm.resourceFileExtension
    }
  }) : _vm._e(), _c('p', {
    staticClass: "button-text color-darkest-gray",
    class: _vm.$style.headTitle,
    attrs: {
      "data-resource-block-title": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.resource.title) + " ")])], 1), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.resource.resourceId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.body
  }, [_c('p', {
    staticClass: "p2",
    class: _vm.$style.bodyExcerpt
  }, [_vm._v(_vm._s(_vm.resource.excerpt))]), _c('p', {
    staticClass: "button-text color-darkest-gray",
    class: _vm.$style.bodyTitle
  }, [_vm._v(_vm._s(_vm.resource.title))])]), _c('div', {
    class: _vm.$style.footer
  }, [_c('div', {
    staticClass: "tagsContainer",
    class: _vm.$style.tagsContainer
  }, _vm._l(_vm.resource.tags, function (tag) {
    return _c('span', {
      key: tag,
      staticClass: "tag-text"
    }, [_vm._v(_vm._s(tag))]);
  }), 0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.resource.isDownloadable,
      expression: "resource.isDownloadable"
    }],
    class: _vm.$style.downloadButton,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.downloadAsset.apply(null, arguments);
      }
    }
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Download",
      "icon-color": "gray"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.resource.isDownloadable,
      expression: "resource.isDownloadable"
    }],
    class: _vm.$style.downloadButtonMinimalInMobile,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.downloadAsset.apply(null, arguments);
      }
    }
  }, [_c('span', [_vm._v("Download")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }